const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/trainer-registration",
    name: "Register",
    component: () => import("@/views/NewRegistrationPage.vue"),
    meta: {
      requiresAuth: true,
      // requiresUser: true,
      // requiresTrainer: false,
    }
  },
  {
    path: "/sign-up",
    name: "CompleteSignup",
    component: () => import("@/views/Signup.vue"),
  },
  {
    path: "/change-password/:token?",
    name: "ChangePassword",
    component: () => import("@/views/ChangePassword.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/ResetPassword.vue"),
  },
  {
    path: "/password/reset/:token?",
    name: "VerifyToken",
    component: () => import("@/views/VerifyToken.vue"),
  },
  {
    path: "/verify/:token?",
    name: "WaitingPage",
    component: () => import("@/views/WaitingPage.vue"),
  },
  {
    path: "/registration",
    name: "Registration",
    component: () => import("@/views/sections/Registration.vue"),
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("@/views/Help.vue"),
  },
  {
    path: "/privacy",
    name: "PrivacyPolicy",
    component: () => import("@/views/PrivacyPolicy.vue"),
  },
  {
    path: "/terms-of-use",
    name: "TermsOfUse",
    component: () => import("@/views/TermsOfUse.vue"),
  },
  {
    path: "/documentation",
    name: "Documentation",
    component: () => import("@/views/Documentation.vue"),
  },
  {
    path: "/support",
    name: "Support",
    component: () => import("@/views/Support.vue"),
  },
  // routes for user
  {
    path: "/",
    name: "DashboardBeforeLogin",
    component: () => import("@/views/user/DashboardBeforeLogin.vue"),
    meta: {
      requiresAuth: true,
      // requiresUser: true,
      // requiresTrainer: false,
    }
  },
  {
    path: "/home",
    name: "Newhome",
    component: () => import("@/views/user/NewHome.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/register/account-type",
    name: "AccountType",
    component: () => import("@/views/user/AccountType.vue"),
  },
  {
    path: "/user/registration-details",
    name: "UserRegistrationDetails",
    component: () => import("@/views/user/UserRegistrationDetails.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/notifications",
    name: "UserNotification",
    component: () => import("@/views/user/notification/UserNotification.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/profile",
    name: "UserProfile",
    component: () => import("@/views/user/profile/UserProfile.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/settings",
    name: "UserSettings",
    component: () => import("@/views/user/profile/UserSettings.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/sessions",
    name: "UserSessions",
    component: () => import("@/views/user/UserSessions.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/sessions/all",
    name: "AllSessions",
    component: () => import("@/views/user/AllSessions.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  // {
  //   path: "/user/trending/sessions",
  //   name: "UserTrendingSessions",
  //   component: () => import("@/views/user/UserTrendingSessions.vue"),
  //   meta: {
  //     requiresAuth: false,
  //     requiresUser: true,
  //     requiresTrainer: false,
  //   },
  // },
  // {
  //   path: "/user/trending/courses",
  //   name: "UserTrendingCourses",
  //   component: () => import("@/views/user/UserTrendingCourses.vue"),
  //   meta: {
  //     requiresAuth: false,
  //     requiresUser: true,
  //     requiresTrainer: false,
  //   },
  // },
  // {
  //   path: "/user/top-categories",
  //   name: "TopCategories",
  //   component: () => import("@/views/user/TopCategoriesCardList.vue"),
  //   meta: {
  //     requiresAuth: false,
  //     requiresUser: true,
  //     requiresTrainer: false,
  //   },
  // },
  {
    path: "/user/recommended/sessions",
    name: "UserRecommendedSessions",
    component: () => import("@/views/user/UserRecommendedSessions.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/recommended/courses",
    name: "UserRecommendedCourses",
    component: () => import("@/views/user/UserRecommendedCourses.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/followed-trainer-posts",
    name: "UserFollowedTrainerPosts",
    component: () => import("@/views/user/UserFollowedTrainerPosts.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/addmoney",
    name: "UserAddMoney",
    component: () => import("@/views/user/AddMoney/AddMoney.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/addmoney/success",
    name: "UserAddMoneySuccess",
    component: () => import("@/views/user/AddMoney/AddMoneySuccess.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/session/live/:id",
    name: "UserSessionLive",
    component: () => import("@/views/user/session/UserSessionLive.vue"),
    meta: {
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/calendar",
    name: "UserCalendar",
    component: () => import("@/views/user/UserCalendar.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/sessions/list",
    name: "SessionsFind",
    component: () => import("@/views/user/session/SessionsList.vue"),
    meta: {
      // requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/list",
    name: "VodList",
    component: () => import("@/views/user/vod/VodList.vue"),
    meta: {
      // requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/details",
    name: "VodDetails",
    component: () => import("@/views/user/vod/VodDetails.vue"),
    meta: {
      // requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/vodclasses",
    name: "VodClasses",
    component: () => import("@/views/user/vod/VodClasses.vue"),
    meta: {
      // requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/chat",
    name: "UserMessage",
    component: () => import("@/views/user/message/UserMessage.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/trainer/:trainer_id",
    name: "UserTrainerShow",
    component: () => import("@/views/user/trainer/UserTrainer.vue"),
    children: [
      {
        path: "about",
        name: "UserTrainerAbout",
        component: () => import("@/views/user/trainer/TrainerAbout.vue"),
      },
      {
        path: "review",
        name: "UserTrainerReview",
        component: () => import("@/views/user/trainer/TrainerReview.vue"),
      },
      {
        path: "post",
        name: "UserTrainerPost",
        component: () => import("@/views/user/trainer/TrainerPost.vue"),
      },
      {
        path: "post/:id",
        name: "UserTrainerPostView",
        component: () => import("@/views/user/trainer/TrainerPostView.vue"),
      },
      {
        path: "store",
        name: "UserTrainerStore",
        component: () => import("@/views/user/trainer/TrainerStore.vue"),
      },
      {
        path: "active",
        name: "UserTrainerActive",
        component: () =>
          import("@/views/user/trainer/TrainerActiveSessionCardList.vue"),
      },
    ],
    meta: {
      // requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/user/session/details/:id",
    name: "UserSessionDetails",
    component: () => import("@/views/user/session/SessionDetails.vue"),
    meta: {
      // requiresAuth: true,
      // requiresUser: true,
      // requiresTrainer: false,
    },
  },
  {
    path: "/user/course/details/:id",
    name: "UserCourseDetails",
    component: () => import("@/views/user/course/CourseDetails.vue"),
    meta: {
      // requiresAuth: true,
      // requiresUser: true,
      // requiresTrainer: false,
    },
  },
  {
    path: "/user/trainers/list",
    name: "TrainersFind",
    component: () => import("@/views/user/trainer/TrainersList.vue"),
    meta: {
      // requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  // routes for trainer
  {
    path: "/dashboard",
    name: "dashboard",
    // component: () => import("@/views/trainer/Dashboard.vue"),
    component: () => import("@/views/trainer/NewDashboard.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/music/:cat?",
    name: "music",
    component: () => import("@/views/trainer/Music.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/favorite/:cat?",
    name: "favorite",
    component: () => import("@/views/trainer/Favorite.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/playlist/:cat?",
    name: "playlist",
    component: () => import("@/views/trainer/Playlist.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/sessions/upcoming",
    name: "upcomingSessions",
    component: () => import("@/views/trainer/session/UpcomingSessions.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/notifications",
    name: "TrainerNotification",
    component: () => import("@/views/trainer/notification/Notification.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/session/upcoming",
    name: "SessionUpcoming",
    component: () => import("@/views/trainer/session/SessionUpcoming.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/earnings",
    name: "earnings",
    component: () => import("@/views/trainer/earnings/Earnings.vue"),
    children: [
      {
        path: "overview",
        name: "EarningsOverview",
        component: () =>
          import("@/views/trainer/earnings/EarningsOverview.vue"),
      },
      {
        path: "history",
        name: "EarningsHistory",
        component: () => import("@/views/trainer/earnings/EarningsHistory.vue"),
      },
      {
        path: "session",
        name: "EarningsSession",
        component: () => import("@/views/trainer/earnings/EarningsSession.vue"),
      },
      {
        path: "sales",
        name: "EarningsSales",
        component: () => import("@/views/trainer/earnings/EarningsSales.vue"),
      },
      {
        path: "users",
        name: "EarningUsers",
        component: () => import("@/views/trainer/earnings/EarningUsers.vue"),
      },
      {
        path: "tips",
        name: "EarningsTips",
        component: () => import("@/views/trainer/earnings/EarningsTips.vue"),
      },
      // {
      //   path: "account",
      //   name: "EarningsAccount",
      //   component: () => import("@/views/trainer/earnings/EarningsAccount.vue"),
      // },
      // {
      //   path: "payouts",
      //   name: "EarningsPayouts",
      //   component: () => import("@/views/trainer/earnings/EarningsPayouts.vue"),
      // },
    ],
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/registration-details",
    name: "TrainerRegistrationDetails",
    component: () => import("@/views/trainer/TrainerRegistrationDetails.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/session/live/:id",
    name: "TrainerSessionLive",
    component: () => import("@/views/trainer/session/TrainerSessionLive.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/calendar",
    name: "TrainerCalendar",
    component: () => import("@/views/trainer/TrainerCalendar.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/sessions/:id?",
    name: "sessions",
    component: () => import("@/views/trainer/session/Sessions.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/chat",
    name: "TrainerMessage",
    component: () => import("@/views/trainer/message/TrainerMessage.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/session/create",
    name: "createSession",
    component: () => import("@/views/trainer/session/CreateSession.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/session/:id",
    name: "session",
    component: () => import("@/views/trainer/session/SingleSession.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/session/history/:id",
    name: "SessionHistory",
    component: () => import("@/views/trainer/session/SessionHistory.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/course/history/:id",
    name: "CourseHistory",
    component: () => import("@/views/trainer/course/CourseHistory.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/session/edit/:id",
    name: "SessionEdit",
    component: () => import("@/views/trainer/session/CreateSession.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/course/create",
    name: "createCourse",
    component: () => import("@/views/trainer/course/CreateCourse.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/course/:id",
    name: "course",
    component: () => import("@/views/trainer/course/SingleCourse.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/course/edit/:id",
    name: "CourseEdit",
    component: () => import("@/views/trainer/course/CourseEdit.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/profile",
    name: "TrainerProfile",
    component: () => import("@/views/trainer/profile/TrainerProfile.vue"),
    children: [
      {
        path: "about",
        name: "TrainerProfileAbout",
        component: () =>
          import("@/views/trainer/profile/TrainerProfileAbout.vue"),
      },
      {
        path: "review",
        name: "TrainerProfileReview",
        component: () =>
          import("@/views/trainer/profile/TrainerProfileReview.vue"),
      },
      {
        path: "sales",
        name: "TrainerProfileSales",
        component: () => import("@/views/trainer/profile/TrainerProfileSales.vue"),
      },
      {
        path: "post",
        name: "TrainerProfilePost",
        component: () =>
          import("@/views/trainer/profile/TrainerProfilePost.vue"),
      },
      {
        path: "post/:id",
        name: "TrainerProfilePostView",
        component: () =>
          import("@/views/trainer/profile/TrainerProfilePostView.vue"),
      },
      {
        path: "store",
        name: "TrainerProfileStore",
        component: () =>
          import("@/views/trainer/profile/TrainerProfileStore.vue"),
      },
      {
        path: "on-demend-classes",
        name: "TrainerProfileVod",
        component: () =>
          import("@/views/trainer/profile/TrainerProfileVod.vue"),
      },
      {
        path: "integrations",
        name: "TrainerProfileIntegrations",
        component: () =>
          import("@/views/trainer/profile/TrainerProfileIntegrations.vue"),
      },
    ],
    meta: {
      // requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/profile/settings",
    name: "TrainerSettings",
    component: () => import("@/views/trainer/profile/TrainerSettings.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/trainer/profile/Edit",
    name: "TrainerProfileEdit",
    component: () => import("@/views/trainer/profile/TrainerProfileEdit.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: false,
      requiresTrainer: true,
    },
  },
  {
    path: "/user/profile/edit",
    name: "UserProfileEdit",
    component: () => import("@/views/user/profile/UserProfileEdit.vue"),
    meta: {
      requiresAuth: true,
      requiresUser: true,
      requiresTrainer: false,
    },
  },
  {
    path: "/trainer/livestream",
    name: "livestream",
    component: () => import("@/views/feedback/Livestream.vue"),
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/components/layouts/AdminLayout.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
    children: [
      {
        path: "/admin/dashboard",
        name: "AdminDashboard",
        component: () => import("@/views/admin/AdminDashboard.vue"),
      },
      {
        path: "/admin/trainers",
        name: "AdminTrainers",
        component: () => import("@/views/admin/AdminTrainers.vue"),
      },
      {
        path: "/admin/trainers/statistics",
        name: "AdminStats",
        component: () => import("@/views/admin/AdminTrainersStats.vue"),
      },
      {
        path: "/admin/trainers/profile",
        name: "AdminTrainerProfileViewer",
        component: () => import("@/views/admin/AdminProfileViewer.vue"),
        children: [
          {
            path: "about/:id",
            name: "AdminTrainersProfileAbout",
            component: () => import("@/views/trainer/profile/TrainerProfileAbout.vue"),
          },
          {
            path: "sales/:id",
            name: "AdminTrainerProfileSales",
            component: () => import("@/views/trainer/profile/TrainerProfileSales.vue"),
          },
          {
            path: "post/:id",
            name: "AdminTrainerProfilePost",
            component: () => import("@/views/trainer/profile/TrainerProfilePost.vue"),
          },
          {
            path: "on-demend-classes/:id",
            name: "AdminTrainerProfileVod",
            component: () =>
              import("@/views/trainer/profile/TrainerProfileVod.vue"),
          },
          {
            path: "integrations/:id",
            name: "AdminTrainerProfileIntegrations",
            component: () =>
              import("@/views/trainer/profile/TrainerProfileIntegrations.vue"),
          }
        ]
      },
      {
        path: "/admin/users/profile",
        name: "AdminUserProfileViewer",
        component: () => import("@/views/admin/AdminProfileViewer.vue"),
        children: [
          {
            path: "/admin/users/profile/about/:id",
            name: "AdminUsersProfileAbout",
            component: () => import("@/views/user/profile/UserProfile.vue"),
          }
        ]
      },
      {
        path: "/admin/users",
        name: "AdminUsers",
        component: () => import("@/views/admin/AdminUsers.vue"),
      },
      {
        path: "/admin/configuration",
        name: "AdminConfiguration",
        component: () => import("@/views/admin/AdminConfiguration.vue")
      },
      {
        path: "/sessions",
        name: "Sessions",
        component: () => import("@/views/admin/Sessions.vue"),
      },
      {
        path: "/courses",
        name: "Courses",
        component: () => import("@/views/admin/Courses.vue"),
      },
      {
        path: "/batches",
        name: "Batches",
        component: () => import("@/views/admin/Batches.vue"),
      },
      {
        path: "/orders",
        name: "Orders",
        component: () => import("@/views/admin/Orders.vue"),
      },
    ]
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/views/feedback/NotFound.vue"),
  },
];

export default routes;